/**
 * Where the app-promotion controls send the customer (PRD 3.1 "App Promotion"; KOVA-796 scope 5–6).
 *
 * None of the three is final — PRD WPV1-1 (the OneLink, the UTM / attribution tags for the store links)
 * is still being coordinated by Mikhail Vasilev with Product / A. Khloponin, and KOVA-796 stays open until
 * it lands. Until then: the store links are the PRD's bare store URLs (no tags), and the QR encodes the Kova
 * OneLink the funnel already uses for its "Download the app" QR (med-web-funnel, `featureFlags.onelink`) —
 * a working link to the app, not the approved one. Swap them here when approved; nothing else in the shell
 * knows the URLs. The QR is drawn client-side (`qrcode.vue`, as in the funnel) so the destination never
 * goes to a third-party QR service.
 *
 * Tracking: the two store links in `PortalAppPromotion` are the click locations KOVA-802 instruments; the
 * desktop QR is scanned, not clicked, so its attribution rides on the OneLink. The shell invents no events.
 */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/kova-weight/id6775505632'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.trykova.app'
export const APP_QR_URL = 'https://trykova.onelink.me/5A6x/5dny01ig'
